import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as R from 'ramda'

import { setArchivedJobs } from 'ducks/concurrency'
import { useModal, useSnackbar } from 'hooks'

const useArchiveJobsModalMutations = ({ archived }) => {
  const dispatch = useDispatch()

  const handleArchiveJobs = React.useCallback(
    ({ onShowSnackbar }) => {
      dispatch(setArchivedJobs(onShowSnackbar, archived))
    },
    [dispatch, archived],
  )

  return {
    handleArchiveJobs,
  }
}

export const useArchiveJobsModalState = () => {
  const { projects } = useSelector(state => state.orm)

  const pks = R.keys(projects?.meta?.selected) || []

  const count = R.length(pks)

  const jobs = R.filter(
    ({ id }) => R.includes(id?.toString(), pks),
    R.values(projects?.items),
  )

  return {
    state: {
      count,
      jobs,
      pks,
    },
  }
}

export const useArchiveJobsModal = ({ archived }) => {
  const { isOpen, handleClose, handleOpen } = useModal()

  const {
    handlers: { handleShowSnackbar },
  } = useSnackbar()

  const { handleArchiveJobs } = useArchiveJobsModalMutations({ archived })

  const handleConfirm = React.useCallback(() => {
    handleArchiveJobs({ onShowSnackbar: handleShowSnackbar })
    handleClose()
  }, [handleClose, handleArchiveJobs, handleShowSnackbar])

  return {
    handleArchiveJobsModalClose: handleClose,
    handleArchiveJobsModalConfirm: handleConfirm,
    handleArchiveJobsModalOpen: handleOpen,
    isArchiveJobsModalOpen: isOpen,
  }
}
